import { getAxiosWithInterceptors } from "@src/app/api/utils";
import { AxiosInstance } from "axios";

import { LocationTrackingMode } from "./cbh-main-api.types";

export class CbhMainApi {
  constructor(private readonly axios: AxiosInstance) {}

  async getLocationTrackingMode(workerId: string, platform: string): Promise<LocationTrackingMode> {
    const response = await this.axios.get(
      `/urgentShifts/location-tracking-mode?workerId=${workerId}&platform=${platform}`
    );
    return response?.data;
  }
}

const axios = getAxiosWithInterceptors();

export const cbhMainApi = new CbhMainApi(axios);
